import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { isEmpty } from 'ramda'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Typography } from '@material-ui/core'

import { useAppName } from 'commons/usePartner'
import { channelsList } from 'app/constants/messageDetail'

import ChannelIcon from 'app/componentV4/Channel/ChannelIcon'
import LightTooltip from 'app/componentV4/Tooltip/LightTooltip'
import { channelName } from 'app/componentV4/Channel/ChannelsName'

const Channels = (props) => {
  const { channels, isTooltip, className } = props

  const appName = useAppName()
  const { formatMessage } = useIntl()
  const [isShowItems, setIsShowItems] = useState([])
  const [isHoverItems, setIsHoverItems] = useState([])

  const handleChannel = (isHoverItems) => {
    return (
      <div className="p-3 space-y-5">
        {isHoverItems.map((item, index) => (
          <div className="space-x-3 flex al-center" key={index}>
            <ChannelIcon channel={Number(channelsList[item].id)} />
            <Typography className="text-12 font-medium text-primary">
              {channelName(item, appName)}
            </Typography>
          </div>
        ))}
      </div>
    )
  }

  useEffect(() => {
    if (isTooltip) {
      if (channels.length > 3) {
        setIsShowItems(channels.slice(0, 4))
        setIsHoverItems(channels.slice(4))
      } else {
        setIsShowItems(channels.slice(0))
        setIsHoverItems([])
      }
    } else {
      setIsShowItems(channels)
    }
  }, [channels, isTooltip])

  return (
    <>
      {isTooltip ? (
        <div className={clsx(className, 'flex space-x-3 items-center')}>
          {isEmpty(isShowItems) ? (
            <Typography className="text-14 text-neutrals-600 font-normal">
              -
            </Typography>
          ) : (
            <div className="flex space-x-3">
              {isShowItems.map((item, index) => (
                <div className="h-20" key={index}>
                  <ChannelIcon channel={Number(channelsList[item].id)} />
                </div>
              )) ?? null}
            </div>
          )}
          {isEmpty(isHoverItems) ? null : (
            <LightTooltip
              title={handleChannel(isHoverItems)}
              placement="bottom-start"
            >
              <Typography className="rounded-full text-neutrals-600 flex justify-center w-20 h-20 text-12 cursor-pointer">
                {`+${isHoverItems.length}`}
              </Typography>
            </LightTooltip>
          )}
        </div>
      ) : (
        <div className="flex space-x-3">
          {isShowItems.map((item, index) => (
            <div className="h-20" key={index}>
              <ChannelIcon channel={Number(channelsList[item].id)} />
            </div>
          )) ?? null}
        </div>
      )}
    </>
  )
}

Channels.propTypes = {
  isTooltip: PropTypes.bool,
  className: PropTypes.string,
  channels: PropTypes.arrayOf(PropTypes.number),
}

export default React.memo(Channels)
